const reviewTypes = {
  SET_REVIEWS: "SET_REVIEWS",
};

export default reviewTypes;
